import React, { useEffect } from 'react';
import {
  Label,
  UncontrolledTooltip,
} from 'reactstrap';
import Services from './services';
import _ from 'lodash';
import { DatetimePicker} from '../../../commons/controls';
import Lib from '../../../commons/lib';
import RFField from '../../../components/Form/RFField';
import SelectField from '../../../components/Form/SelectField';
import moment from 'moment';

const AlkalomForm = props => {
  let selected = false;

  const {
    musor,
    formTerem,
    formTeremkiosztas,
    formAzonosito,
    formEsemenyKezdete,
    formEsemenyVege,
    formFoglalasKezdete,
    formFoglalasVege,
    formVasarlasKezdete,
    formVasarlasVege,
    formEsemenyTipus,
    formPublikus,
    formMaxjegyszam,
    formKenyelmidij,
    formKenyelmidijsz,
    formRendelesIdoLimit,
    formRendelesTorlesIdoLimit,
    formTulajdonsag,
    formPenznem,
    formAllapot,
    jegySWExists,
    handleChangeInput,
    handleDateInputChange,
    handleSelectInputChange,
    penznemOptions,
    kenyelmiDijParam,
    kenyelmiDijInputChecker
  } = props;

  const loadTeremkiosztasOptions = (input, callback) => {
    Services.listTeremkiosztas(musor.helyszinId, formTeremkiosztas && formTeremkiosztas.kod, (err, res) => {
      if (!err) {
        let options = [];
        if(res[0][musor.helyszinId]){
          res[0][musor.helyszinId].filter( tk => tk.nev.toLowerCase().includes(input.toLowerCase())).forEach((item) => {
            options.push(item);
          });
        }
        callback(options);
      }
    });
  }

  const loadTeremOptions = (input, callback) => {
    Services.listTeremSelect(musor.helyszinId, (err, res) => {
      if (!err) {
        let options = [];
        res[0].filter( t => t.nev.toLowerCase().includes(input.toLowerCase())).forEach((item) => {
          options.push(item);
        });
        callback(options);
      }
    });
  }

  const loadTulajdonsagOptions = (input, callback) => {
    Services.listTulajdonsag((err, res) => {
      if (!err) {
        let options = [];
        res[0].filter( t => t.leiras.toLowerCase().includes(input.toLowerCase())).forEach((item) => {
          options.push(item);
        });
        callback(options);
      }
    });
  }

  const loadEsemenyTipusOptions = (input, callback) => {
    Services.listEsemenyTipus((err, res) => {
      if (!err) {
        let options = [];
        res[0].filter( t => t.cap.toLowerCase().includes(input.toLowerCase())).forEach((item) => {
          options.push(item);
        });
        callback(options);
      }
    });
  }

  const handleDateChange = (e,v,type) => {
    if(selected) {
      selected = false;
      let date = moment(e).startOf('day');
      switch (type) {
        case 'FORMESEMENYKEZDETE':
          // Igény, hogy ha már töltve van az időpont, akkor onnantól kezdve ne legyen nullázva dátum választáskor
          if (formEsemenyKezdete != null) {
            date = moment(e);
          }
          handleDateInputChange(null, date, "formEsemenyKezdete");
          break;
        case 'FORMESEMENYVEGE':
          handleDateInputChange(null, date, "formEsemenyVege");
          break;
        case 'FORMFOGLALASKEZDETE':
          handleDateInputChange(null, date, "formFoglalasKezdete");
          break;
        case 'FORMFOGLALASVEGE':
          handleDateInputChange(null, date, "formFoglalasVege");
          break;
        case 'FORMVASARLASKEZDETE':
          handleDateInputChange(null, date, "formVasarlasKezdete");
          break;
        case 'FORMVASARLASVEGE':
          handleDateInputChange(null, date, "formVasarlasVege");
          break;
        default:
          break;
      }
    } else {
      switch (type) {
        case 'FORMESEMENYKEZDETE':
          handleDateInputChange(null, v === '' ? v : e, "formEsemenyKezdete");
          break;
        case 'FORMESEMENYVEGE':
          handleDateInputChange(null, v === '' ? v : e, "formEsemenyVege");
          break;
        case 'FORMFOGLALASKEZDETE':
          handleDateInputChange(null, v === '' ? v : e, "formFoglalasKezdete");
          break;
        case 'FORMFOGLALASVEGE':
          handleDateInputChange(null, v === '' ? v : e, "formFoglalasVege");
          break;
        case 'FORMVASARLASKEZDETE':
          handleDateInputChange(null, v === '' ? v : e, "formVasarlasKezdete");
          break;
        case 'FORMVASARLASVEGE':
          handleDateInputChange(null, v === '' ? v : e, "formVasarlasVege");
          break;
        default:
          break;
      }
    }
  }

  return (
    <div className="row">
      <div className="col-md-6">
        {jegySWExists ? 
          <React.Fragment>
            <SelectField
              label='Teremkiosztás:'
              variant='async'
              styles={{
                control: base => ({
                  ...base,
                  marginBottom: '20px'
                }),
              }}
              id={"formTeremkiosztas"}
              name={"formTeremkiosztas"}
              placeholder="Kezdj el gépelni..."
              noOptionsMessage={() => 'Nincs keresési eredmény'}
              onChange={v => handleSelectInputChange(v, "formTeremkiosztas")}
              loadOptions={_.debounce(loadTeremkiosztasOptions, 1000)}
              getOptionLabel={option => option.nev}
              getOptionValue={option => option.kod}
              value={formTeremkiosztas}
              cache={false}
              isClearable
              defaultOptions
            />
          </React.Fragment>
        :
          <React.Fragment>
            <SelectField
              variant='async'
              label='Terem:'
              styles={{
                control: base => ({
                  ...base,
                  marginBottom: '20px'
                }),
              }}
              id={"formTerem"}
              name={"formTerem"}
              placeholder="Kezdj el gépelni..."
              noOptionsMessage={() => 'Nincs keresési eredmény'}
              onChange={v => handleSelectInputChange(v, "formTerem")}
              loadOptions={_.debounce(loadTeremOptions, 1000)}
              getOptionLabel={option => option.nev}
              getOptionValue={option => option.id}
              value={formTerem}
              cache={false}
              isClearable
              defaultOptions
            />
          </React.Fragment>}
      </div>
      <div className="col-md-3">
          <RFField
            label={'Állapot: '}
            name={"formAllapot"}
            id={"formAllapot"}
            type="text"
            disabled
            value={formAllapot}
          />
      </div>
      <div className="col-md-3">
          <RFField
            label={'Azonosító: '}
            name={"formAzonosito"}
            id={"formAzonosito"}
            type="text"
            value={formAzonosito}
            disabled
          />
      </div>
      <div className="col-md-3">
        <SelectField
          variant='async'
          label='Tulajdonság:'
          styles={{
            control: base => ({
              ...base,
              '&:focus': { borderColor: 'red' }, // border style on hover
              border: '1px solid lightgray', // default border color
              boxShadow: 'none', // no box-shadow
              borderRadius: '0',
              marginBottom: '20px'
            }),
          }}
          id={"formTulajdonsag"}
          name={"formTulajdonsag"}
          placeholder="Kezdj el gépelni..."
          noOptionsMessage={() => 'Nincs keresési eredmény'}
          onChange={v => handleSelectInputChange(v, "formTulajdonsag")}
          loadOptions={_.debounce(loadTulajdonsagOptions, 1000)}
          getOptionLabel={option => option.leiras}
          getOptionValue={option => option.id}
          value={formTulajdonsag}
          cache={false}
          isClearable
          defaultOptions
        />
      </div>
      <div className='col-md-2'>
        <RFField
          label={'Max. jegyszám: '}
          regex={['^[0-9]*$', 'Számokat tartalmazó mező!']}
          name={"formMaxjegyszam"}
          id={"formMaxjegyszam"}
          type="text"
          value={formMaxjegyszam}
          onChange={handleChangeInput}
        />
      </div>
      <div className="col-md-2">
        <SelectField
          label='Pénznem:'
          isDisabled
          styles={{
            control: base => ({
              ...base,
              '&:focus': { borderColor: 'red' }, // border style on hover
              border: '1px solid lightgray', // default border color
              boxShadow: 'none', // no box-shadow
              borderRadius: '0',
              marginBottom: '20px'
            }),
          }}
          id={"formPenznem"}
          name={"formPenznem"}
          placeholder="Kezdj el gépelni..."
          noOptionsMessage={() => 'Nincs keresési eredmény'}
          options={penznemOptions}
          getOptionLabel={option => option.azonosito}
          getOptionValue={option => option.id}
          value={formPenznem}
          cache={false}
          isClearable
          defaultOptions
        />
      </div>
      {kenyelmiDijParam && <>
        <div className="col-md-2">
          <RFField
            label={'Kényelmi díj összege: '}
            regex={['^[0-9\.]*$', 'Számokat tartalmazó mező!']}
            name={"formKenyelmidij"}
            id={"formKenyelmidij"}
            type="text"
            value={formKenyelmidij}
            autoComplete="off"
            onKeyDown={(e) => {
              if (!kenyelmiDijInputChecker(e, e.target.value, formPenznem?.tizedesjegy))
                e.preventDefault();
            }}
            onChange={(e,v) => {
              if (kenyelmiDijInputChecker(e, v, formPenznem?.tizedesjegy))
                handleChangeInput(e);
            }}
          />
        </div>
        <div className="col-md-2">
          <RFField
            label={'Kényelmi díj %: '}
            regex={['^[0-9\.]*$', 'Számokat tartalmazó mező!']}
            name={"formKenyelmidijsz"}
            id={"formKenyelmidijsz"}
            type="text"
            value={formKenyelmidijsz}
            autoComplete="off"
            onKeyDown={(e) => {
              if (!kenyelmiDijInputChecker(e, e.target.value, 2))
                e.preventDefault();
            }}
            onChange={(e,v) => {
              if (kenyelmiDijInputChecker(e, v, 2))
                handleChangeInput(e);
            }}
          />
        </div>
      </>}
      <div className="col-md-5">
        <SelectField
          variant='async'
          label='Esemény típusa:'
          styles={{
            control: base => ({
              ...base,
              marginBottom: '20px'
            }),
          }}
          id={"formEsemenyTipus"}
          name={"formEsemenyTipus"}
          placeholder="Kezdj el gépelni..."
          noOptionsMessage={() => 'Nincs keresési eredmény'}
          onChange={v => handleSelectInputChange(v, "formEsemenyTipus")}
          loadOptions={_.debounce(loadEsemenyTipusOptions, 1000)}
          getOptionLabel={option => option.cap}
          getOptionValue={option => option.nam}
          value={formEsemenyTipus}
          cache={false}
          isClearable
          defaultOptions
        />
      </div>
      <div className='w-100 mb-1'></div>
      <div className="col-md-5">
        <DatetimePicker
          label={'Előadás kezdete: '}
          required
          id={"formEsemenyKezdete"}
          name={"formEsemenyKezdete"}
          value={formEsemenyKezdete && new Date(formEsemenyKezdete)}
          onChange={(e,v) => {handleDateChange(e,v,'FORMESEMENYKEZDETE')}}
          onSelect={(e,v) => { selected = true }}
          timePrecision="seconds"
        />
      </div>
      <div className="col-md-5">
        <DatetimePicker
          label={'Előadás vége: '}
          required
          id={"formEsemenyVege"}
          name={"formEsemenyVege"}
          value={formEsemenyVege && new Date(formEsemenyVege)}
          onChange={(e,v) => {handleDateChange(e,v,'FORMESEMENYVEGE')}}
          onSelect={(e,v) => { selected = true }}
          timePrecision="seconds"
        />
      </div>
      <div className="col-md-5">
        <DatetimePicker
          label={'Foglalás kezdete: '}
          required
          id={"formFoglalasKezdete"}
          name={"formFoglalasKezdete"}
          value={formFoglalasKezdete && new Date(formFoglalasKezdete)}
          onChange={(e,v) => handleDateChange(e,v,'FORMFOGLALASKEZDETE')}
          onSelect={(e,v) => { selected = true }}
          timePrecision="seconds"
        />
      </div>
      <div className="col-md-5">
        <DatetimePicker
          label={'Foglalás vége: '}
          required
          id={"formFoglalasVege"}
          name={"formFoglalasVege"}
          value={formFoglalasVege && new Date(formFoglalasVege)}
          onChange={(e,v) => handleDateChange(e,v,'FORMFOGLALASVEGE')}
          onSelect={(e,v) => { selected = true }}
          timePrecision="seconds"
        />
      </div>
      <div className="col-md-5">
        <DatetimePicker
          label={'Értékesítés kezdete: '}
          required
          id={"formVasarlasKezdete"}
          name={"formVasarlasKezdete"}
          value={formVasarlasKezdete && new Date(formVasarlasKezdete)}
          onChange={(e,v) => handleDateChange(e,v,'FORMVASARLASKEZDETE')}
          onSelect={(e,v) => { selected = true }}
          timePrecision="seconds"
        />
      </div>
      <div className="col-md-5">
        <DatetimePicker
          label={'Értékesítés vége: '}
          required
          id={"formVasarlasVege"}
          name={"formVasarlasVege"}
          value={formVasarlasVege && new Date(formVasarlasVege)}
          onChange={(e,v) => handleDateChange(e,v,'FORMVASARLASVEGE')}
          onSelect={(e,v) => { selected = true }}
          timePrecision="seconds"
        />
      </div>
      <div className="col-md-3">
          <RFField
            label={'Rendelés időlimit (perc): '}
            regex={['^[0-9]*$', 'Számokat tartalmazó mező!']}
            name={"formRendelesIdoLimit"}
            id={"formRendelesIdoLimit"}
            type="text"
            value={formRendelesIdoLimit}
            onChange={handleChangeInput}
          />
      </div>
      <div className="col-md-3">
        <div>
          <Label for={"formRendelesTorlesIdoLimit"} >Rendelés törlés időlimit (perc): 
            <i
              style={{ marginTop: 0 }}
              id={"formRendelesTorlesIdoLimitInfo"}
              aria-label="Ha az érték negatív, akkor az előadás kezdete előtt törlődnek a foglalások/vásárlások."
              className="fa fa-info-circle table-action-icon transp-icon-button"
            />
            <UncontrolledTooltip trigger='hover focus-visible'
              placement="top"
              target={"formRendelesTorlesIdoLimitInfo"}
              delay={0}
            >
              {' Ha az érték negatív, akkor az előadás kezdete előtt törlődnek a foglalások/vásárlások.'}
            </UncontrolledTooltip>
          </Label>
          <RFField
            regex={['^-[0-9]*$', 'Számokat tartalmazó mező!']}
            name={"formRendelesTorlesIdoLimit"}
            id={"formRendelesTorlesIdoLimit"}
            type="text"
            value={formRendelesTorlesIdoLimit}
            onChange={handleChangeInput}
          />
        </div>
      </div>
      <div className="col-md-2" style={{marginTop: "34px"}}>
          <RFField 
            label={'Publikus'}
            type="checkbox" 
            name={"formPublikus"}
            value={formPublikus}
            onChange={handleChangeInput}
          />
      </div>
    </div>
  );
}

export default AlkalomForm;